export const getMessages = state => {
  return state.Messages.messages;
};

export const isMessagesLoading = state => {
  return state.Messages.loading;
};

export const getScrollToBottom = state => {
  return state.Messages.scrollToBottom;
};

export const getIntervalCounter = state => {
  return state.Messages.intervalCounter;
};

export const getLimitReached = state => {
  return state.Messages.limitReached;
};

export const isMessageStreaming = state => {
  return state.Messages.streaming;
};

// export const getBusyMessage = state => {
//   return state.Messages.busyMessage;
// };

// export const getLimitMessage = state => {
//   return state.Messages.limitMessage;
// };

// export const getScrollToBottom = state => {
//   return state.Messages.scrollToBottom;
// };

// export const getScrollToBottom = state => {
//   return state.Messages.scrollToBottom;
// };
